module.exports = __webpack_public_path__ + "img/hk.a915e270.png";